import { Chip } from "@mui/material";
import {
  AtTagOrganizationProps,
  AtTagOrganizationStatus,
} from "../at-tag.types";

export const TagOrganization = ({ status }: AtTagOrganizationProps) => {
  const { borderColor, textColor } = getColor(status);
  const text = getLabel(status);

  return (
    <Chip
      label={text}
      className={`!text-xs !font-medium !bg-white !border-solid !border ${borderColor} ${textColor}`}
    />
  );
};

const getLabel = (status: AtTagOrganizationStatus) => {
  switch (status) {
    case AtTagOrganizationStatus.LIVERPOOL:
      return "Liverpool";
    case AtTagOrganizationStatus.SUBURBIA:
      return "Suburbia";
  }
};

const getColor = (status: AtTagOrganizationStatus) => {
  switch (status) {
    case AtTagOrganizationStatus.LIVERPOOL:
      return {
        borderColor: "!border-liverpool",
        textColor: "!text-liverpool",
      };
    case AtTagOrganizationStatus.SUBURBIA:
      return {
        borderColor: "!border-suburbia",
        textColor: "!text-suburbia",
      };
  }
};
